import { mapGetters } from "vuex";
import variables from "@/styles/variables.scss";

export default {
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
    sidebarComponent: {
      type: Object,
      default: () => {},
    },
    bookmarkTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSidebar: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    handleWindowResize(event) {
      this.showSidebar = this.getWindowWidth(event) > variables.bpSizeMedium;
    },
  },
};
